<template>
  <div class="ts-loader" v-loading="true"></div>
</template>

<style lang="scss" scoped>
.ts-loader::v-deep {
  .el-loading-mask {
    background: none;
  }

  .el-loading-spinner .path {
    stroke: #187a5c;
  }
}
</style>

<script>
export default {
  name: 'TsLoader'
};
</script>
